import * as types from '../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  user: [],
  error: null,
};

const GetVendorsFilterListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_VENDORS_FILTER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_VENDORS_FILTER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.GET_VENDORS_FILTER_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default GetVendorsFilterListReducer;
